/**
 * Apply Page (Stub)
 * P20250925-125 — Minimal stub for Apply Free Use CTA
 */

import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { fireEvent } from '@/lib/analytics';

export default function ApplyStub() {
  const navigate = useNavigate();

  useEffect(() => {
    fireEvent('apply_stub_view', {});
  }, []);

  return (
    <>
      <Helmet>
        <title>Apply for Free Use - Coming Soon</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="max-w-md text-center space-y-6">
          <h1 className="text-4xl font-bold">Apply for Free Use</h1>
          <p className="text-lg text-muted-foreground">
            Our application program is coming soon. Check back later or contact me for details.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button onClick={() => navigate('/support/contact')}>Contact Me</Button>
            <Button variant="outline" onClick={() => navigate('/domains')}>
              Explore Domains
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
